import { Injectable } from '@angular/core';
import { NavigationEnd, Resolve, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Request } from 'src/app/core/clientHttp/request';
import { HttpService } from 'src/app/core/clientHttp/http.service';
// import { NoticeComponent } from 'src/app/shared/components/notice/notice.component';
import { ClientLoaderService } from 'src/app/shared/components/client-loader/client-loader.service';
import { StepsModel } from './steps.model';
import { StepApplymentService } from '@app/services/applyment/step/step-applyment.service';
import { ApplymentModel } from '@app/services/client-general-settings/applyment/applyment.model';
import { StartApplymentService } from '@app/services/applyment/process-selection/start-applyment/start-applyment.service';

@Injectable({
  providedIn: 'root'
})
export class GetStepsService extends Request implements Resolve<GetStepsService> {

  constructor(
    private http: HttpService,
    private stepsModel: StepsModel,
    private applymentModel: ApplymentModel,
    private route: Router
  ) {
    super();
  }

  private response: any = null;
  public data = {
    execute_stage_query: null,
    token: null,
    process_id: null,
  };

  resolve(
    activatedRouteSnapshot: ActivatedRouteSnapshot,
  ): Observable<any> | Promise<any> | any {

    this.url = `applyment/getApplymentDataByStep/${activatedRouteSnapshot.params.step}`;

    if (this.data.execute_stage_query === null) {
      this.data.execute_stage_query = 1;
    }

    if (localStorage.getItem('token')) {
      this.data.token = localStorage.getItem('token');
    }

    if (localStorage.getItem('process_id')) {
      this.data.process_id = localStorage.getItem('process_id');
    }

    return this.http.post(this).then((data) => this.response);
  }

  successAction(data) {
    this.response = data;
    if (data.success) {
      this.stepsModel.setSteps(data.data);
    } else {
      this.route.navigate(['/' + this.applymentModel.settings.domain], {queryParamsHandling: 'preserve'});
      this.stepsModel.setSteps(null);
    }
  }

}
